










































































import {
    Vue,
    Component
} from "@/shared/vuepack";
import SettingsHeader from "@/employee/components/settings/SettingsHeader.vue";
import SettingsNavigation from "@/employee/components/settings/SettingsNavigation.vue";
import { useDebitCardManagementStore } from "@/shared/store/debitCardManagement";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import * as RouteNames from "@/employee/route-names";
import {
    CardStatus,
    DebitCardRecord,
    FetchState,
    DebitCardManagerModalViewState
} from "@/shared/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import DebitCardManagerModal from "@/employee/components/settings/card-management/DebitCardManagerModal.vue";

/*
the table will hold a mapped version of DebitCardRecord objects.  So the table's field descriptions will have keys
which match the name of the properties on the DebitCardRecord type.  There is an additional column, "actions", which
hold button controls to make actions on the records in the table
*/
type TableFieldKey = keyof DebitCardRecord | "actions";
interface TableField {
    key: TableFieldKey;
    label: string;
}

@Component({
    components: {
        SettingsHeader,
        SettingsNavigation,
        GenericLoadingSpinner,
        DebitCardManagerModal,
    }
})
export default class DebitCardManager extends Vue {
    debitCardManagementStore = useDebitCardManagementStore();
    featureFlagStore = useFeatureFlagStore();
    DebitCardManagerModalViewState = DebitCardManagerModalViewState;

    mounted (): void {
        this.debitCardManagementStore.loadAll();
    }

    get isTableLoading (): boolean {
        return this.debitCardManagementStore.debitCardsFetchState === FetchState.Loading;
    }

    get tableFields (): TableField[] {
        const capability = this.debitCardManagementStore.cardProviderOptionsOrDefault.capability;

        const tableFields: TableField[] = [];
        tableFields.push({ key: "firstName", label: "Name" });
        tableFields.push({ key: "cardNumberLast4", label: "Card Number" });

        if (capability.canDeactivateCard || capability.canReplaceCard) {
            tableFields.push({ key: "cardStatus", label: "Card Status" });
        }

        if (capability.canInitializePin || capability.canUpdatePin) {
            tableFields.push({ key: "isPinSet", label: "PIN Status" });
        }

        if (capability.canManageCard) {
            tableFields.push({ key: "actions", label: "" });
        }

        return tableFields;
    }

    manageCardClicked (debitCardRecord: DebitCardRecord) {
        this.debitCardManagementStore.setFocusedDebitCard(debitCardRecord);
    }

    requestNewCardClicked () {
        this.debitCardManagementStore.setModalState(DebitCardManagerModalViewState.RequestNewCardForm);
    }

    getCardStatus (cardStatus: CardStatus) {
      switch (cardStatus) {
        case CardStatus.LostOrDamaged:
        case CardStatus.FraudOrStolen:
        case CardStatus.Fraud:
        case CardStatus.Stolen:
        case CardStatus.ReplacementRequested:
          return "Replacement Requested";
        case CardStatus.PendingClose:
          return "Active";
        default:
            return cardStatus;
        }
    }
}

